import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=22414884&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"
import style0 from "./errors.scss?vue&type=style&index=0&id=22414884&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22414884",
  null
  
)

export default component.exports